module.exports = __webpack_public_path__ + "static/card-5-2c8650e0a8ad622e0e88a7e780ad9097.png";